/**
 * Datenschutzerklärung nach Art. 13 DSGVO für die Nutzerdaten der Testfassung.
 *
 * Abgegrenzt von der Auftragsverarbeitung (die regelt der AVV in den
 * Nutzungsbedingungen): hier geht es um die Daten, für die H&K selbst
 * Verantwortlicher ist, also die Registrierungs- und Nutzungsdaten des
 * Steuerberaters, nicht die hochgeladenen Mandantendaten.
 */
import { Link } from 'react-router'

export function DatenschutzSeite() {
  return (
    <div className="recht-seite">
      <div className="recht-spalte">
        <Link to="/" className="verweis zurueck">
          Zurück
        </Link>

        <h1>Datenschutzerklärung</h1>
        <p className="leiser">Fassung 2026-09-19</p>

        <p>
          Diese Erklärung betrifft die Daten, die wir über Sie als Nutzer der Testfassung verarbeiten. Für die
          Kontoauszüge, die Sie hochladen, sind Sie Verantwortlicher und wir Auftragsverarbeiter, das regelt die
          Vereinbarung zur Auftragsverarbeitung in den{' '}
          <Link to="/bedingungen" className="verweis">
            Nutzungsbedingungen
          </Link>
          .
        </p>

        <h2>1. Verantwortlicher</h2>
        <p>
          H&amp;K Automation GbR, Obere Burghalde 92, 71229 Leonberg. Kontakt: louis.honal@hks-automation.de. Ein
          Datenschutzbeauftragter ist gesetzlich nicht vorgeschrieben und nicht bestellt.
        </p>

        <h2>2. Welche Daten wir verarbeiten und wofür</h2>
        <ul>
          <li>
            <b>Registrierung:</b> Vorname, Nachname, E-Mail-Adresse und, falls angegeben, Kanzleiname. Zweck: den
            Zugang bereitstellen und Ihnen bei Rückfragen antworten. Rechtsgrundlage Art. 6 Abs. 1 lit. b DSGVO
            (Nutzungsverhältnis) und lit. f (unser Interesse, den Test zu betreuen und nachzufragen, wie er lief).
          </li>
          <li>
            <b>Passwort:</b> nur als Argon2id-Hash gespeichert, nie im Klartext.
          </li>
          <li>
            <b>Sitzung und Sicherheit:</b> ein technisch notwendiges Sitzungs-Cookie sowie zur Missbrauchsabwehr ein
            nicht rückrechenbarer Tageshash aus Ihrer IP-Adresse. Die IP-Adresse selbst speichern wir dafür nicht.
            Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO.
          </li>
          <li>
            <b>Protokoll:</b> dass und wann ein Zugriff erfolgt ist, ohne Beträge, Namen oder IBAN. Zweck: Sicherheit
            und Nachweis. Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO.
          </li>
        </ul>

        <h2>3. Empfänger</h2>
        <p>
          Der Betrieb läuft bei der Hetzner Online GmbH in Deutschland. Das Sprachmodell für die Auszüge läuft über
          Amazon Web Services in der EU-Region Frankfurt. Einzelheiten und die Einordnung als Unterauftragsverarbeiter
          stehen in der Vereinbarung zur Auftragsverarbeitung. Eine Weitergabe Ihrer Registrierungsdaten zu Werbe- oder
          sonstigen fremden Zwecken findet nicht statt.
        </p>

        <h2>4. Speicherdauer</h2>
        <p>
          Hochgeladene Auszüge und Ergebnisse werden nach der in den Bedingungen genannten Frist automatisch gelöscht.
          Ihre Registrierungsdaten löschen wir, sobald Sie es verlangen oder der Zugang erkennbar nicht mehr genutzt
          wird, spätestens nach Ende der Testphase.
        </p>

        <h2>5. Ihre Rechte</h2>
        <p>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit und Widerspruch
          gegen eine Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Eine Mail an
          louis.honal@hks-automation.de genügt. Sie haben außerdem das Recht, sich bei einer Aufsichtsbehörde zu
          beschweren, zuständig ist der Landesbeauftragte für den Datenschutz und die Informationsfreiheit
          Baden-Württemberg.
        </p>

        <h2>6. Keine Weitergabe in Drittländer zu eigenen Zwecken</h2>
        <p>
          Ihre Registrierungsdaten verarbeiten wir in der EU. Zum Restrisiko beim Sprachmodell siehe die Vereinbarung
          zur Auftragsverarbeitung.
        </p>

        <Link to="/" className="verweis zurueck">
          Zurück
        </Link>
      </div>
    </div>
  )
}
